import React, { useState } from 'react';

import ActionButton from '../../../components/ActionButton';
import { message } from 'antd';

import { getDownloadLinks } from '../../../utils/services/statusTrackingAPI';
import { withTranslation } from 'react-i18next';
import { STATUS_MONITORING as trans } from './TranslationValues';

const actualFileDownload = async (directoryHandle, fileLink, fileName, index) => {
     try {
       console.log("File link to be fetched :: ", fileLink, fileName);
       const fetchResponse = await fetch(fileLink);
       const fileContents = await fetchResponse.blob();
       const draftHandle = await directoryHandle.getFileHandle(`${fileName}.pdf`, { create: true });
       // create a FileSystemWritableFileStream to write to
       const writableStream = await draftHandle.createWritable();
       console.log({ writableStream });
       // write our file
       await writableStream.write(fileContents);
       // close the file and write the contents to disk.
       await writableStream.close();
       console.log("Returning true");
       return true;
     } catch (err) {
       console.log("Returning false || throwing error");
       throw err;
     }
   }

const JobDownload = (props) => {
  const { t } = props;
  const [downloadProgress, setDownloadProgress] = useState(0);
  const { activeItem } = props;

  console.log({ downloadProgress });

  return (
                  <ActionButton
                    small
                    /*label={t(
                      trans.REVIEW_AND_APPROVE_BUTTON.key,
                      trans.REVIEW_AND_APPROVE_BUTTON.value,
                    )}*/
                    label={downloadProgress > 0 ? t(trans.DOWNLOADING_LABEL.key, trans.DOWNLOADING_LABEL.value) : t(trans.DOWNLOAD_LABEL.key, trans.DOWNLOAD_LABEL.value)}
                    onClick={async (e) => {
                      e.stopPropagation();
                      if (downloadProgress > 0) {
                        return;
                      }
                      let isSuccessful = false;
                      let isCancelled = false;
                      try {
                        const response = await getDownloadLinks(parseInt(activeItem?.id));
                        console.log({ response });
                        if (response.statusCode !== 200) {
                          message.error(t(trans.DOWNLOAD_ERROR.key, trans.DOWNLOAD_ERROR.value));
                          return;
                        }
                        const filesToDownload = response.fileNames.map(fileName => {
                          return `${response.baseUrl}${fileName}?${response.token}`;
                        })
                        console.log({ filesToDownload });
                        const directoryHandle = await window.showDirectoryPicker();
                        console.log({ directoryHandle });

                        // Try first file and then handle with promise all
                        const firstFileDownload = await actualFileDownload(directoryHandle, filesToDownload[0], response.fileNames[0], 0);
                        let restOfFiles = filesToDownload.slice(1);
                        setDownloadProgress(1);

                        const finishWriting = await Promise.all(restOfFiles.map((fileLink, index) => {
                          return new Promise((resolve, reject) => {
                            actualFileDownload(directoryHandle, fileLink, response.fileNames[index + 1], index).then((value) => {
                              setDownloadProgress(count => count + 1);
                              resolve(value);
                            }).catch(err => {
                              console.log("Error in getting file handle :: ", err, finishWriting);
                              reject(err);
                              throw err;
                            })
                          })
                        }));
                        console.log({ firstFileDownload, restOfFiles });
                        isSuccessful = finishWriting.reduce((acc, status) => acc && status, true);
                      } catch (err) {
                        console.log("Unable to download :: ", err);
                        if(err?.name === 'AbortError'){
                          isCancelled = true;
                        }
                        isSuccessful = false;
                      } finally {
                        setTimeout(() => {
                          setDownloadProgress(0);
                          if (isSuccessful) {
                            message.success(t(trans.DOWNLOAD_SUCCESS.key, trans.DOWNLOAD_SUCCESS.value));
                          } else if(!isSuccessful && !isCancelled) {
                            // TODO : error message
                            message.error(t(trans.DOWNLOAD_ERROR.key, trans.DOWNLOAD_ERROR.value));
                          }
                        }, 1000);
                      }
                    }}
                  />
  )
}

export default withTranslation(['STATUS_MONITORING'])(JobDownload);